"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

import { cn } from "~/lib/utils";

function Switch({ className, ...props }: SwitchPrimitive.Root.Props) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "relative inline-flex h-touch w-14 shrink-0 cursor-pointer touch-manipulation items-center rounded-full bg-transparent p-0 outline-none transition-[box-shadow] duration-200 [--thumb-size:--spacing(6)] before:absolute before:left-1/2 before:top-1/2 before:h-[calc(var(--thumb-size)+2px)] before:w-[calc(var(--thumb-size)*2-2px)] before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:bg-input before:transition-colors before:duration-200 before:content-[''] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background data-checked:before:bg-primary data-disabled:cursor-not-allowed data-disabled:opacity-64 md:h-[calc(var(--thumb-size)+2px)] md:w-[calc(var(--thumb-size)*2-2px)] md:[--thumb-size:--spacing(4)] md:before:inset-0 md:before:translate-x-0 md:before:translate-y-0",
        className,
      )}
      data-slot="switch"
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none absolute left-[6px] top-1/2 block aspect-square h-(--thumb-size) origin-left -translate-y-1/2 rounded-(--thumb-size) bg-background shadow-sm/5 will-change-transform [transition:translate_.15s,border-radius_.15s,scale_.1s_.1s,transform-origin_.15s] data-checked:origin-[var(--thumb-size)_50%] data-checked:translate-x-[calc(var(--thumb-size)-4px)] md:left-px",
        )}
        data-slot="switch-thumb"
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
